// @flow

import { ReducerRegistry } from '../base/redux';

import {
    CALL_AFTER_CONFERENCE_INITIATE,
    HANGUP_MEET
} from './actionTypes';

const DEFAULT_STATE = {
    /**
     * The indicator which determines whether (the) {@code CalleeInfo} is
     * visible.
     *
     * @type {boolean|undefined}
     */
};

ReducerRegistry.register('features/panther', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case CALL_AFTER_CONFERENCE_INITIATE:
        return {
            ...state,
            phoneNumber: action.phoneNumber
        };
    case HANGUP_MEET:
        return {
            ...state,
            phoneNumber: ''
        };
    }


    return state;
});
